import {
  LayoutDashboard, Search, PackageSearch, PlusCircle, Send, Plane, Package,
  MessageSquare, Bell, User, ShieldCheck, LifeBuoy, Settings, Shield,
} from "lucide-react";

export const NAV_ITEMS = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/find-deliveries", label: "Find Deliveries", icon: PackageSearch, testid: "nav-find-deliveries" },
  { to: "/find-travellers", label: "Find Travellers", icon: Search, testid: "nav-find-travellers" },
  { to: "/create-trip", label: "Post a Trip", icon: Plane, testid: "nav-create-trip" },
  { to: "/create-delivery", label: "Send a Package", icon: PlusCircle, testid: "nav-create-delivery" },
  { to: "/my-trips", label: "My Trips", icon: Send, testid: "nav-my-trips" },
  { to: "/my-deliveries", label: "My Deliveries", icon: Package, testid: "nav-my-deliveries" },
  { to: "/messages", label: "Messages", icon: MessageSquare, testid: "nav-messages" },
  { to: "/notifications", label: "Notifications", icon: Bell, testid: "nav-notifications" },
  { to: "/profile", label: "Profile", icon: User, testid: "nav-profile" },
  { to: "/safety", label: "Safety", icon: ShieldCheck, testid: "nav-safety" },
  { to: "/support", label: "Support", icon: LifeBuoy, testid: "nav-support" },
  { to: "/settings", label: "Settings", icon: Settings, testid: "nav-settings" },
];

export const ADMIN_NAV = { to: "/admin", label: "Admin", icon: Shield, testid: "nav-admin" };

export const PACKAGE_CATEGORIES = ["Documents", "Clothing", "Electronics", "Food", "Personal Items", "Other"];
export const PACKAGE_SIZES = ["Small", "Medium", "Large"];
export const CAPACITY_OPTIONS = ["Small (up to 2kg)", "Medium (up to 5kg)", "Large (up to 10kg)", "Extra (10kg+)"];
export const TRAVEL_MODES = ["Flight", "Train", "Bus", "Car", "Bike", "Other"];
export const VEHICLE_MODES = ["Car", "Bike"];
export const VEHICLE_TYPES = ["Car", "Bike / Motorcycle", "Scooter", "SUV", "Van", "Other"];
export const CANCEL_REASONS = ["Plans changed", "No longer needed", "Unable to send package", "Travel arrangement changed", "Other"];

export const DELIVERY_STATUS_COLORS = {
  Requested: "bg-slate-100 text-slate-700 border-slate-200",
  Matched: "bg-sky-100 text-sky-700 border-sky-200",
  Accepted: "bg-blue-100 text-blue-700 border-blue-200",
  "Pickup Pending": "bg-indigo-100 text-indigo-700 border-indigo-200",
  "Picked Up": "bg-violet-100 text-violet-700 border-violet-200",
  "In Transit": "bg-amber-100 text-amber-700 border-amber-200",
  "Out for Delivery": "bg-orange-100 text-orange-700 border-orange-200",
  Delivered: "bg-emerald-100 text-emerald-700 border-emerald-200",
  Cancelled: "bg-rose-100 text-rose-700 border-rose-200",
  Upcoming: "bg-sky-100 text-sky-700 border-sky-200",
  Active: "bg-blue-100 text-blue-700 border-blue-200",
  Completed: "bg-emerald-100 text-emerald-700 border-emerald-200",
};

export const ACCOUNT_DELETION_URL = "https://sites.google.com/view/pack-mate/delete-account";
